import angular from 'angular';

class ModalConfirmPortalCtrl {
  /*@ngInject*/
  constructor() {}

  activate() {
    this.modalInstance.close();
  }

  cancel() {
    this.modalInstance.dismiss('cancel');
  }
}

angular.module('app.principal').component('modalConfirmPortal', {
  templateUrl: require('./modal-confirm-portal.html'),
  controller: ModalConfirmPortalCtrl,
  bindings: {
    modalInstance: '<'
  }
});
